import alerts from "./alerts";

const validarUnidadSinOrdenTrabajo = async (api, unidad) => {
    if (!unidad?.id) {
        return true;
    }

    try {
        const respuesta =
            await api.obtenerOrdenesTrabajoAbiertas(unidad.id);

        const ordenes =
            respuesta?.ordenesTrabajo ??
            respuesta?.OrdenesTrabajo ??
            [];

        const tieneOrdenAbierta =
            respuesta?.tieneOrdenTrabajoAbierta === true ||
            respuesta?.TieneOrdenTrabajoAbierta === true ||
            ordenes.length > 0;

        if (!tieneOrdenAbierta) {
            return true;
        }

        const folios = ordenes
            .map(orden =>
                orden.numeroOrdenTrabajo ??
                orden.NumeroOrdenTrabajo ??
                orden.codigo ??
                orden.Codigo ??
                orden.id
            )
            .filter(Boolean);

        const detalle = folios.length
            ? `: ${folios.join(", ")}`
            : "";

        alerts.aviso(
            `La unidad ${
                unidad.nombre ??
                unidad.numeroEconomico ??
                ""
            } tiene órdenes de trabajo abiertas${detalle}. ` +
            "No puede seleccionarse."
        );

        return false;
    } catch {
        alerts.aviso(
            "No fue posible validar las órdenes de trabajo " +
            "de la unidad."
        );

        return false;
    }
};

export default validarUnidadSinOrdenTrabajo;